module.exports = __webpack_public_path__ + "img/google.1a91bff8.svg";